import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { AuthenticationFailedPayload } from './interfaces/authentication-failed-payload.interface';
import { isNonNullObject } from 'utilities';

export const AuthenticationFailedMessage: MessageHandler<AuthenticationFailedPayload> = {
  send(payload: AuthenticationFailedPayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.AuthenticationFailed, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is AuthenticationFailedPayload {
    return (
      isNonNullObject(payload) &&
      'reason' in payload &&
      typeof payload.reason === 'string' &&
      (!('code' in payload) || typeof payload.code === 'string')
    );
  },
};
